import {
  WRITTEN_PHOTO_SPEC_FOOTER,
  WRITTEN_PHOTO_SPEC_SECTIONS,
} from '@/data/exam.notice.data';

import WrittenNoticeSheetSectionCard from './written-notice-sheet-section-card.client';

/** 준비물 > 증명사진 규격 BottomSheet 스크롤 본문(헤더는 BottomSheet `headerContent`) */
export default function WrittenPrepPhotoSpecSheet() {
  return (
    <div className="px-3 pb-8 pt-5 bg-[#F5F5FA]">
      <div className="flex flex-col gap-5">
        {WRITTEN_PHOTO_SPEC_SECTIONS.map((section) => (
          <WrittenNoticeSheetSectionCard
            key={section.title}
            section={section}
          />
        ))}
      </div>
      <p className="mt-5 typo-13 font-semibold leading-snug text-[#FB4040] whitespace-pre-line">
        {WRITTEN_PHOTO_SPEC_FOOTER}
      </p>
    </div>
  );
}
